import { useContext, useMemo } from 'react';
import { type ChatContextItem, ChatContextType } from '@trinity/chat';
import { ActiveChatSessionContext } from '@trinity/chat-components/components/Chat/context';
import { useHeaderContext } from '../context';

export function useContextSelectoryDisplayValue() {
  const {
    pendingContext,
    pendingContextType,
  } = useHeaderContext();
  const session = useContext(ActiveChatSessionContext);

  return useMemo(() => {
    if (pendingContext) {
      return getContextDisplayText(pendingContextType, pendingContext);
    }

    if (session.context?.type === ChatContextType.Agent) {
      // return trunc(session.context.data.name, 15);
      return session.context.data.name;
    }

    if (session.context?.type === ChatContextType.Folder) {
      return session.context.metadata?.name || 'Folder';
    }

    if (session.context?.type === ChatContextType.Document) {
      return session.context.metadata?.name || 'Document';
    }

    return getContextDisplayText(session.context?.type);
  }, [pendingContextType, session.context.data, session.context?.type, session.context?.metadata]);
}

function getContextDisplayText(contextType: ChatContextType, context?: ChatContextItem): string {
  switch (contextType) {
    case ChatContextType.Document:
      return 'Document';
    case ChatContextType.Folder:
      return 'Folder';
    case ChatContextType.Transcript:
      return 'Transcript';
    case ChatContextType.Global:
      return 'Everything';
    case ChatContextType.KolProfile:
      return 'Profile';
    case ChatContextType.Agent: {
      return context.name;
    }
    case ChatContextType.Brand:
      return 'Brand';
    case ChatContextType.Project:
      return 'Project';
    case ChatContextType.MessageGeneration:
      return context?.name || 'Message Generation';

    default:
      throw new UnreachableCaseError(contextType);
  }
}